import { useQuery } from '@tanstack/react-query';

import { generateRenewalList } from '../Admin.api';

export default function useRenewalListQuery(options?: any) {
  return useQuery(['renewalList'], generateRenewalList, options);
}
